/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerFindByScopeIdQueryResponse, ProjectsControllerFindByScopeIdPathParams, ProjectsControllerFindByScopeIdQueryParams, ProjectsControllerFindByScopeId400, ProjectsControllerFindByScopeId401, ProjectsControllerFindByScopeId403, ProjectsControllerFindByScopeId404 } from "../../models/projectsController/ProjectsControllerFindByScopeId";

function getProjectsControllerFindByScopeIdUrl(scopeId: ProjectsControllerFindByScopeIdPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/scopes/${scopeId}/project` as const }  
  return res
}

/**
 * @summary Get a project by scope ID
 * {@link /api/v1/scopes/:scopeId/project}
 */
export async function projectsControllerFindByScopeId(scopeId: ProjectsControllerFindByScopeIdPathParams["scopeId"], params?: ProjectsControllerFindByScopeIdQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectsControllerFindByScopeIdQueryResponse, ResponseErrorConfig<ProjectsControllerFindByScopeId400 | ProjectsControllerFindByScopeId401 | ProjectsControllerFindByScopeId403 | ProjectsControllerFindByScopeId404>, unknown>({ method : "GET", url : getProjectsControllerFindByScopeIdUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}